<template>
  <div>
    <v-row>
      <v-col cols="12" sm="12">
        <v-text-field v-model="name" label="Part Name"/>
        <v-text-field v-model.number="price" label="Part Cost"/>
        <v-btn @click="addPart" color="primary">Add Part</v-btn>
      </v-col>
      <v-col v-if="renderComponent" cols="12" sm="12">
        <v-data-iterator :items="estimate.parts">
          <template v-slot:default="props">
            <v-row>
              <v-col class="mt-2" cols="12" v-for="(item, index) in props.items" :key="index">
                <v-card>
                  <v-card-title>
                    <v-icon left>mdi-tools</v-icon>
                    {{ item.name }} - £{{ item.price }}
                  </v-card-title>
                  <v-card-actions>
                    <v-btn color="error" @click="removePart(item.name)" text fab icon>
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </template>
        </v-data-iterator>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {EventBus} from "@/EventBus";

export default {
  name: "EstimateParts",
  props: {
    estimate: Object,
    embedded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      name: '',
      price: null,
      renderComponent: true
    }
  },
  methods: {
    forceRerender() {
      // Remove my-component from the DOM
      this.renderComponent = false;

      this.$nextTick(() => {
        // Add the component back in
        this.renderComponent = true;
      });
    },
    addPart() {
      if (this.name.length > 0) {
        if (this.embedded) {
          this.$emit('estimate-part-added', {name: this.name, price: this.price});
        } else {
          EventBus.$emit('estimate-part-added', {name: this.name, price: this.price});
        }
        this.name = '';
        this.price = null;
        this.forceRerender();
      }
    },
    removePart(name) {
      if (this.embedded) {
        this.$emit('estimate-part-removed', name);
      } else {
        EventBus.$emit('estimate-part-removed', name);
      }
    }
  }
}
</script>
